<template>
  <!-- <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
      <ion-button class="button_back" data-testid="directions-107" @click="goBack">
        <ion-icon name="arrow-back-outline"> </ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button data-testid="directions-108" @click="skip">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar> -->

  <ion-toolbar>
    <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length || ['locum_jobseeker_cv',].includes(routeName)">
      <ion-button color="warning" class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end" v-if="!['locum_jobseeker_cv'].includes(routeName)">
      <ion-button data-testid="directions-108" @click="skip" class="pill next-pill-button">
        <span>Skip</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="main_wrapper main_wrapper--p ion-padding">
    <el-form>
      <el-form-item v-if="routeName == 'cv_upload'">
        <el-button v-if="data.cv.disabled" class="submit_page" type="blue" data-testid="directions-111"
          :disabled="files.length == 0" @click="next()">
          <span>Continue</span>
        </el-button>
      </el-form-item>
    </el-form>

    <div class="container">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Upload Resume</h1>
          <p class="auth-subtext">Please upload your latest resume!</p>
        </div>
        <div class="brand-icon">
          <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
        </div>
      </div>
      <div>
        <p>Upload your resume so our AI can enhance your profile, making it easier for you to apply for jobs
          that
          perfectly match your skills and experience</p>

      </div>
    
      <el-form class="full_page" v-if="files.length == 0">
        <div class="upload-image">
          <img :src="require('@/assets/img/job-seeker/upload-resume.png')" alt="">
          <div class="file-upload-label">
            <h3>Browse Your Files</h3>
            <p>Support Format : PDF | Maximum 10 MB </p>
          </div>
        </div>
        <el-form-item>
          <el-upload data-testid="directions-109" name="files" class="uploader-support" :thumbnail-mode="true"
            list-type="picture" :action="'upload'" :drag="true" :auto-upload="false" accept="application/pdf" :limit="1"
            :on-change="uploader.handleChange">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Upload File
            </div>
            <template #file="{ file }">
              <div>
                <div v-if="file.raw.type == 'application/pdf'" style="display: flex; align-items: center;">
                  <img src="@/assets/img/new-pdf-icon.svg" alt="" class="header_logo_text">
                  <span class="mx-2" size="large">{{ file.name }}</span>
                </div>
                <div v-else>
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="{{ file.name }}" />
                </div>
              </div>
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-delete" @click="uploader.handleRemove(file)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21.07 5.23C19.46 5.07 17.85 4.95 16.23 4.86V4.85L16.01 3.55C15.86 2.63 15.64 1.25 13.3 1.25H10.68C8.35004 1.25 8.13003 2.57 7.97004 3.54L7.76004 4.82C6.83004 4.88 5.90004 4.94 4.97004 5.03L2.93004 5.23C2.51004 5.27 2.21004 5.64 2.25004 6.05C2.29004 6.46 2.65004 6.76 3.07004 6.72L5.11004 6.52C10.35 6 15.63 6.2 20.93 6.73C20.96 6.73 20.98 6.73 21.01 6.73C21.39 6.73 21.72 6.44 21.76 6.05C21.79 5.64 21.49 5.27 21.07 5.23Z"
                      fill="#E64558" />
                    <path
                      d="M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14ZM13.66 17.75H10.33C9.91999 17.75 9.57999 17.41 9.57999 17C9.57999 16.59 9.91999 16.25 10.33 16.25H13.66C14.07 16.25 14.41 16.59 14.41 17C14.41 17.41 14.07 17.75 13.66 17.75ZM14.5 13.75H9.49999C9.08999 13.75 8.74999 13.41 8.74999 13C8.74999 12.59 9.08999 12.25 9.49999 12.25H14.5C14.91 12.25 15.25 12.59 15.25 13C15.25 13.41 14.91 13.75 14.5 13.75Z"
                      fill="#E64558" />
                  </svg>

                </span>
              </span>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item class="button_submit mb0">
          <el-button v-if="files.length == 0 && !data.cv.disabled" class="submit_page btn-primary"
            data-testid="directions-110" type="blue" @click="submit()">
            <span v-if="routeName == 'profile_cv'">Save <i class="el-icon-right"></i></span>
            <span v-else>Continue</span>
          </el-button>
        </el-form-item>
      </el-form>
      <div class="preview_square preview_square-block" :class="{ 'el-form full_page': files.length > 0 }"
        v-if="files.length > 0">
        <div class="proof-ins" v-if="files.length == 0">Your Cv</div>
        <div class="el-upload-list" style="display:flex">
          <div class="el-upload-list__item" v-for="(file, index) in files" :key="file.url">
            <div class="thumbnail_img el-upload-list--picture-card">
              <div v-if="file.extension == 'pdf'">
                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text" />
              </div>

              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="openPdf(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span class="el-upload-list__item-delete" @click="deletePdf(file, index)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <div class="upload-text" style="margin-top: 6px;">
              {{ file.fileName }}
            </div>
          </div>
        </div>
        <el-button class="submit_page btn-primary submit" type="blue" @click="next()">
          <span>Continue</span>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, onBeforeMount } from "vue";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  ElMessage,
  ElMessageBox as MessageBox,
} from "@/components/Vendor/Element";
import FileHelpers from "@/helpers/file/file";
import formHooks from "@/hooks/form/form";
import { indexOf } from "lodash";
import store from "@/store/store";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { isAustraliaRegion, isUSRegion } from '@/helpers/region/regionHelper.js';

export default {
  components: {
    "ion-toolbar": IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  setup() {
    const $router = useRouter();
    const $route = useRoute();
    const $store = useStore();
    const fileHelper = new FileHelpers();
    const userInfo = $store.getters.GET_USER_DATA;
    const routeName = $route.name;
    const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();


    const cv = {
      files: [],
      disabled: true,
      validators: [],
      fileType: 9, // locumateCv
    };

    const { setFormRefs: setRefs, formsData: data } = formHooks({
      cv: cv,
    });

    // file handler functions
    const uploader = {
      handleRemove(file) {
        data.cv.files.splice(indexOf(file), 1);
      },
      handleChange(file, files) {
        const fileType = fileHelper.getFileType(file);
        if (fileType !== "pdf") {
          files.pop();
          ElMessage({
            type: "error",
            message: `Document must be PDF format!`,
          });
          return;
        }

        // update files to cv.
        data.cv.files = files;

        // update submit button needs to be enabled.
        data.cv.disabled = computed(() => {
          return data.cv.files.length == 0;
        });
      },
    };

    onMounted(() => {
      setRefs();

    });



    onBeforeMount(async () => {
      try {
        await store.dispatch("SET_CURRENT_USER_DATA", {
          with: "settings,billingInfo,schedule,bankVerification,address,push_notifications,config.hours_before_shift_lock",
        });
        const refreshData = $store.getters.GET_USER_DATA;
        console.log("🚀 ~ onBeforeMount ~ refreshData:", refreshData)
        console.log("allowow", refreshData);
        files.value = refreshData.locumCvs; // Update the userData reactive property
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    });
        
    const goBack = async() => {
      if(routeName == 'locum_jobseeker_cv'){
        $router.push({
          name: "locum_jobseeker_pharmacist_certifications",
        });
      }else{
        const back = await $store.dispatch("getAuthPageBack");
        $router.push({
          name: back,
        });
      }
     
    };

    const skip = () => {
      (async () => {
        
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
          if(routeName == 'locum_jobseeker_cv'){
            $router.push({
              name: "locum_jobseeker_enhance",
            });

           }else{
            $router.push({
              name: "jobseeker_auth_enhance",
            });
           }
        } catch (error) {
          console.log(error);
        }
      })();
    };

    const openPdf = (file) => {
      window.open(file.url, "_blank");
    };
    const deletePdf = async (file) => {
      await MessageBox.confirm(
        `Are you sure you’d like to remove file ?`,
        "Remove your CV",
        {
          confirmButtonText: "Remove",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--red",
          cancelButtonClass: "el-button--grey",
          showClose: false,
        }
      );
      await $store.dispatch("deleteCv", file);
      files.value = files.value.filter((item) => file.id != item.id);
    };
    const submit = () => {
      const form = new FormData();
      let index = 0;
      const uploadedFiles = data.cv.files;

      // prepare the request as a form data.
      if (uploadedFiles.length > 0) {
        uploadedFiles.map((file) => {
          form.append(`file[${index}]`, file.raw);
          index += 1;
        });

        // file type is locumCv
        form.append(`fileType`, data.cv.fileType);
    
        (async () => {
          try {
            await $store.dispatch("saveCv", form);
          } finally {
            console.log("🚀 ~ submit ~ routeName", routeName)
           if(routeName == 'locum_jobseeker_cv'){
            $router.push({
              name: "locum_jobseeker_enhance",
            });

           }else{
            $router.push({
              name: "jobseeker_auth_enhance",
            });
           }
            
          }
        })();
      }
    };
    const next = () => {
     
      if(routeName == 'locum_jobseeker_cv'){
            $router.push({
              name: "locum_jobseeker_enhance",
            });

           }else{
            $router.push({
              name: "jobseeker_auth_enhance",
            });
           }
    };
    const files = ref(userInfo.locumCvs);

    // const cycleMessages = () => {
    //   messageInterval = setInterval(() => {
    //     messageIndex.value = (messageIndex.value + 1) % messages.value.length;
    //     currentMessage.value = messages.value[messageIndex.value];
    //   }, 2000); // Change message every 3 seconds
    // };


    return {
      files,
      uploader,
      data,
      goBack,
      skip,
      openPdf,
      deletePdf,
      submit,
      next,
      routeName,
      isAustralia,
      isUS
      // messages,
      // cycleMessages,
      // currentMessage,
      // messageInterval
    };
  },
};
</script>

<style></style>